(() => {
  const nav = document.getElementById('AccessibleNav');
  if (!nav) return;
  const header = nav.closest('.site-header');
  const roots = [...nav.querySelectorAll(':scope > .first-level-dropdown')];
  const desktop = window.matchMedia('(min-width: 768px)');
  let hoverTimer;
  let closeTimer;
  let hoverCandidate;
  const cancelHover = () => {
    clearTimeout(hoverTimer);
    hoverCandidate = null;
  };
  const show = active => roots.forEach(root => {
    const open = root === active;
    root.classList.toggle('sgg-nav-open', open);
    root.querySelector(':scope > .sgg-nav-toggle')?.setAttribute('aria-expanded', String(open));
  });
  let frame;
  const position = () => {
    frame = null;
    if (!desktop.matches) return;
    const bottom = Math.max(nav.getBoundingClientRect().bottom, header?.getBoundingClientRect().bottom || 0);
    nav.style.setProperty('--sgg-dropdown-top', `${Math.max(0, Math.ceil(bottom))}px`);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(position);
  };
  roots.forEach((root, index) => {
    const link = root.querySelector(':scope > a');
    const dropdown = root.querySelector(':scope > .site-nav__dropdown');
    if (!link || !dropdown) return;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'sgg-nav-toggle';
    toggle.setAttribute('aria-label', `${link.textContent.trim()} – Menü öffnen oder schließen`);
    toggle.setAttribute('aria-expanded', 'false');
    dropdown.id = dropdown.id || `sgg-navigation-${index}`;
    toggle.setAttribute('aria-controls', dropdown.id);
    link.after(toggle);
    toggle.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      cancelHover();
      clearTimeout(closeTimer);
      show(root.classList.contains('sgg-nav-open') ? null : root);
      position();
    });
    root.addEventListener('pointerenter', event => {
      if (!desktop.matches || event.pointerType === 'touch') return;
      clearTimeout(closeTimer);
      cancelHover();
      if (root.classList.contains('sgg-nav-open')) return;
      hoverCandidate = root;
      const switching = roots.some(item => item.classList.contains('sgg-nav-open'));
      hoverTimer = setTimeout(() => {
        if (hoverCandidate !== root || !root.matches(':hover')) return;
        position();
        show(root);
        hoverCandidate = null;
      }, switching ? 550 : 100);
    });
    root.addEventListener('pointerleave', () => {
      if (hoverCandidate === root) cancelHover();
    });
    root.addEventListener('focusout', event => {
      if (!root.contains(event.relatedTarget) && root.classList.contains('sgg-nav-open')) show(null);
    });
    root.addEventListener('keydown', event => {
      if (!desktop.matches) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        cancelHover();
        toggle.focus();
        show(null);
      } else if (event.key === 'ArrowDown' && (event.target === link || event.target === toggle)) {
        event.preventDefault();
        event.stopPropagation();
        show(root);
        dropdown.querySelector('a')?.focus();
      }
    }, true);
  });
  nav.addEventListener('pointerenter', () => clearTimeout(closeTimer));
  nav.addEventListener('pointerleave', () => {
    cancelHover();
    closeTimer = setTimeout(() => {
      if (!nav.matches(':hover') && !nav.contains(document.activeElement)) show(null);
    }, 300);
  });
  document.addEventListener('pointerdown', event => {
    if (!nav.contains(event.target)) {
      cancelHover();
      show(null);
    }
  });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    observer.observe(nav);
    if (header) observer.observe(header);
  }
  document.fonts?.ready.then(schedule);
  position();
})();


(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const launcherSelector = 'button[aria-controls="NavDrawer"]';
  let wasOpen = false;
  let launcher;
  const syncSubmenus = () => {
    document.querySelectorAll('#NavDrawer .mobile-nav__has-sublist').forEach((group, index) => {
      const list = group.nextElementSibling;
      if (!list?.classList.contains('mobile-nav__sublist')) return;
      list.id = list.id || `sgg-mobile-navigation-${index}`;
      const open = group.classList.contains('mobile-nav--expanded');
      const label = group.querySelector(':scope > a')?.textContent.trim();
      group.querySelectorAll(':scope > .mobile-nav__toggle > button').forEach(button => {
        button.setAttribute('aria-controls', list.id);
        button.setAttribute('aria-expanded', String(open));
        button.dataset.sggMenuLabel = button.dataset.sggMenuLabel || button.getAttribute('aria-label') || '';
        if (label) button.setAttribute('aria-label', `${button.dataset.sggMenuLabel}: ${label}`);
      });
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('#NavDrawer .mobile-nav__toggle button');
    if (!button) return;
    const group = button.closest('.mobile-nav__has-sublist');
    const hadFocus = button === document.activeElement || event.detail === 0;
    syncSubmenus();
    if (hadFocus) {
      const selector = group.classList.contains('mobile-nav--expanded') ? '.mobile-nav__toggle-close' : '.mobile-nav__toggle-open';
      group.querySelector(selector)?.focus({ preventScroll: true });
    }
  });
  const focusable = drawer => [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
    .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  const syncMobileMenuState = () => {
    const drawer = document.getElementById('NavDrawer');
    if (!drawer) return;
    const filterOpen = document.querySelector('collection-filtering-form.is-open');
    const open = mobile.matches && document.body.classList.contains('js-drawer-open-left') && !filterOpen;
    const active = document.activeElement;
    drawer.toggleAttribute('inert', !open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (open) drawer.setAttribute('aria-modal', 'true');
    else drawer.removeAttribute('aria-modal');
    document.querySelectorAll(launcherSelector).forEach(button => button.setAttribute('aria-expanded', String(open)));
    if (open && !wasOpen) {
      launcher = active?.matches(launcherSelector) ? active : document.querySelector(launcherSelector);
      drawer.querySelector('.mobile-menu--close-btn')?.focus({ preventScroll: true });
    } else if (!open && wasOpen && drawer.contains(active) && mobile.matches && !filterOpen) {
      launcher?.focus({ preventScroll: true });
    }
    wasOpen = open;
  };
  const observer = new MutationObserver(syncMobileMenuState);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  const observeFilter = () => {
    const filterDrawer = document.querySelector('collection-filtering-form');
    if (filterDrawer) observer.observe(filterDrawer, { attributes: true, attributeFilter: ['class'] });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !wasOpen) return;
    const drawer = document.getElementById('NavDrawer');
    if (!drawer?.contains(event.target)) return;
    const items = focusable(drawer);
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && event.target === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && event.target === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  mobile.addEventListener('change', () => {
    if (!mobile.matches && wasOpen) document.querySelector('#NavDrawer .mobile-menu--close-btn')?.click();
    syncMobileMenuState();
  });
  document.addEventListener('shopify:section:load', () => {
    observeFilter();
    syncSubmenus();
    syncMobileMenuState();
  });
  observeFilter();
  syncSubmenus();
  syncMobileMenuState();
})();
